export const MASTER = 'master';
export const RELEASE = 'release';
